import { render, staticRenderFns } from "./QueryUmaoiS.vue?vue&type=template&id=e216c01e&"
import script from "./QueryUmaoiS.vue?vue&type=script&lang=js&"
export * from "./QueryUmaoiS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports